module.exports = __webpack_public_path__ + "img/smile.4e54f391.jpg";